import { render } from "./CwHeader.vue?vue&type=template&id=459747e8"
import script from "./CwHeader.vue?vue&type=script&lang=js"
export * from "./CwHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__